(function () {
  var menuBtn = document.querySelector("[data-wb-menu]");
  var nav = document.querySelector("[data-wb-nav]");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", function () {
      nav.classList.toggle("is-open");
      menuBtn.classList.toggle("is-open");
    });
  }

  document.querySelectorAll("[data-want-tab]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-want-tab");
      var root = btn.closest("[data-want]");
      if (root) root.setAttribute("data-panel", id);
      document.querySelectorAll("[data-want-tab]").forEach(function (b) { b.classList.toggle("is-active", b === btn); });
      document.querySelectorAll("[data-want-panel]").forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-want-panel") === id);
      });
    });
  });

  var rivals = {
    liv: { name: "LIQUID I.V.", electro: "890MG", sugar: "11G", cal: "45 CAL", b12: "280%", c: "80%" },
    livns: { name: "LIQUID I.V. NO SUGAR", electro: "890MG", sugar: "0G", cal: "15 CAL", b12: "330%", c: "80%" },
    lmnt: { name: "LMNT", electro: "1,260MG", sugar: "0G", cal: "10 CAL", b12: "0%", c: "0%" },
    drip: { name: "DRIPDROP", electro: "556MG", sugar: "7G", cal: "35 CAL", b12: "0%", c: "80%" },
    ultima: { name: "ULTIMA", electro: "613MG", sugar: "0G", cal: "0", b12: "0%", c: "0%" }
  };
  document.querySelectorAll("[data-compare]").forEach(function (root) {
    var select = root.querySelector("[data-compare-select]");
    if (select) {
      select.addEventListener("change", function () {
        var data = rivals[select.value];
        if (!data) return;
        var name = root.querySelector("[data-compare-name]");
        if (name) name.textContent = data.name;
        Object.keys(data).forEach(function (key) {
          if (key === "name") return;
          var cell = root.querySelector('[data-compare-cell="' + key + '"]');
          if (cell) cell.textContent = data[key];
        });
      });
    }
    root.querySelectorAll("[data-compare-col]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-compare-col");
        var on = btn.classList.contains("is-active");
        var activeCount = root.querySelectorAll("[data-compare-col].is-active").length;
        if (on && activeCount < 2) return;
        btn.classList.toggle("is-active");
        var col = root.querySelector(".wb-compare__col.is-" + key);
        if (col) col.classList.toggle("is-off", !btn.classList.contains("is-active"));
      });
    });
  });

  document.querySelectorAll("[data-slider]").forEach(function (root) {
    var track = root.querySelector("[data-slider-track]");
    var prev = root.querySelector("[data-slider-prev]");
    var next = root.querySelector("[data-slider-next]");
    var dots = root.querySelectorAll("[data-slider-dot]");
    var dotsWrap = root.querySelector("[data-slider-dots]");
    var ignoreScroll = 0;
    var scrollTimer;
    if (!track) return;
    function gap() {
      var style = window.getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap) || 16;
    }
    function cardLeft(i) {
      var card = track.children[i];
      if (!card) return 0;
      return card.offsetLeft - track.children[0].offsetLeft;
    }
    function go(i) {
      var max = Math.max(0, track.children.length - 1);
      var n = Math.max(0, Math.min(max, i));
      ignoreScroll = Date.now() + 450;
      track.scrollTo({ left: cardLeft(n), behavior: "smooth" });
      setDots(n);
    }
    function current() {
      var x = track.scrollLeft;
      var best = 0;
      var bestDist = 99999;
      for (var i = 0; i < track.children.length; i++) {
        var d = Math.abs(cardLeft(i) - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function setDots(n) {
      var buttons = dots.length ? dots : (dotsWrap ? dotsWrap.querySelectorAll("button") : []);
      var count = buttons.length;
      buttons.forEach(function (b, i) {
        b.classList.toggle("is-active", count ? i === (n % count) : false);
      });
    }
    if (dotsWrap && !dots.length) {
      for (var i = 0; i < track.children.length; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("data-slider-dot", String(i));
        b.setAttribute("aria-label", "Go to slide " + (i + 1));
        if (i === 0) b.className = "is-active";
        dotsWrap.appendChild(b);
      }
      dots = root.querySelectorAll("[data-slider-dot]");
    }
    dots.forEach(function (dot) {
      dot.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(parseInt(dot.getAttribute("data-slider-dot"), 10) || 0);
      });
    });
    if (prev) prev.addEventListener("click", function () { go(current() - 1); });
    if (next) next.addEventListener("click", function () { go(current() + 1); });
    track.addEventListener("scroll", function () {
      if (Date.now() < ignoreScroll) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { setDots(current()); }, 80);
    });
  });

  document.querySelectorAll("[data-video]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.querySelector("video")) return;
      var video = document.createElement("video");
      video.src = btn.getAttribute("data-video");
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      btn.innerHTML = "";
      btn.appendChild(video);
      video.play().catch(function () {});
    });
  });

  document.querySelectorAll(".wb-pdp__thumb").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var main = document.getElementById("wb-main-img");
      if (main) main.src = btn.getAttribute("data-src");
      document.querySelectorAll(".wb-pdp__thumb").forEach(function (t) { t.classList.toggle("is-active", t === btn); });
    });
  });

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  document.querySelectorAll("[data-mix]").forEach(function (root) {
    var unit = parseInt(root.getAttribute("data-unit"), 10) || 15;
    var price = parseInt(root.getAttribute("data-price"), 10) || 1499;
    var step = 1;
    var qty = {};
    function rows() { return root.querySelectorAll("[data-mix-item]"); }
    function totalQty() {
      var n = 0;
      rows().forEach(function (row) { n += qty[row.getAttribute("data-id")] || 0; });
      return n;
    }
    function render() {
      rows().forEach(function (row) {
        var q = qty[row.getAttribute("data-id")] || 0;
        var pack = row.querySelector("[data-mix-pack]");
        if (pack) pack.textContent = q + (q === 1 ? " pack" : " packs");
        row.classList.toggle("is-on", q > 0);
      });
      var pouches = totalQty() || step;
      var totalEl = root.querySelector("[data-mix-total]");
      var countEl = root.querySelector("[data-mix-count]");
      if (totalEl) totalEl.textContent = money(price * pouches);
      if (countEl) countEl.textContent = pouches + (pouches === 1 ? " pouch" : " pouches") + " · " + (pouches * unit) + " sticks";
      root.querySelectorAll("[data-mix-step]").forEach(function (b) {
        b.classList.toggle("is-active", parseInt(b.getAttribute("data-mix-step"), 10) === step);
      });
    }
    function setStep(n) {
      step = Math.max(1, Math.min(4, n));
      render();
    }
    root.querySelectorAll("[data-mix-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        setStep(parseInt(b.getAttribute("data-mix-step"), 10) || 1);
      });
    });
    root.querySelectorAll("[data-mix-plus]").forEach(function (b) {
      b.addEventListener("click", function () {
        var row = b.closest("[data-mix-item]");
        if (!row) return;
        var id = row.getAttribute("data-id");
        if (totalQty() >= 4) return;
        qty[id] = (qty[id] || 0) + 1;
        if (totalQty() > step) step = totalQty();
        var img = row.getAttribute("data-img");
        var main = document.getElementById("wb-main-img");
        if (main && img) main.src = img;
        render();
      });
    });
    var fill = root.querySelector("[data-mix-fill]");
    if (fill) {
      fill.addEventListener("click", function () {
        qty = {};
        var list = rows();
        for (var i = 0; i < step && i < list.length; i++) {
          qty[list[i].getAttribute("data-id")] = 1;
        }
        if (step > list.length && list[0]) {
          qty[list[0].getAttribute("data-id")] = step - list.length + 1;
        }
        render();
      });
    }
    root.querySelectorAll("input[name='wb-purchase']").forEach(function (radio) {
      radio.addEventListener("change", function () {
        root.querySelectorAll(".wb-mix__plan label").forEach(function (label) {
          label.classList.toggle("is-active", label.querySelector("input").checked);
        });
        var del = root.querySelector("[data-mix-delivery]");
        if (del) del.hidden = root.querySelector("input[name='wb-purchase']:checked").value === "onetime";
      });
    });
    var add = root.querySelector("[data-mix-add]");
    if (add) {
      add.addEventListener("click", function () {
        var cartItems = [];
        rows().forEach(function (row) {
          var q = qty[row.getAttribute("data-id")] || 0;
          if (q) cartItems.push({ id: parseInt(row.getAttribute("data-id"), 10), quantity: q });
        });
        if (!cartItems.length && rows()[0]) {
          cartItems.push({ id: parseInt(rows()[0].getAttribute("data-id"), 10), quantity: step });
        }
        if (!cartItems.length) return;
        add.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: cartItems })
        }).then(function () {
          var delivery = root.querySelector("[data-mix-delivery] select");
          var purchase = root.querySelector("input[name='wb-purchase']:checked");
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              attributes: {
                purchase_type: purchase ? purchase.value : "subscribe",
                delivery: delivery ? delivery.value : "Delivery every month"
              }
            })
          });
        }).then(function () {
          window.location.href = "/cart";
        }).catch(function () {
          add.disabled = false;
        });
      });
    }
    render();
  });

  var nutrition = document.querySelector("[data-nutrition]");
  function closeNutrition() {
    if (!nutrition) return;
    nutrition.hidden = true;
    document.body.classList.remove("wb-lock");
  }
  if (nutrition) {
    document.querySelectorAll("[data-nutrition-open]").forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        nutrition.hidden = false;
        document.body.classList.add("wb-lock");
      });
    });
    nutrition.addEventListener("click", function (event) {
      if (event.target === nutrition || event.target.closest("[data-nutrition-close]")) closeNutrition();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeNutrition();
    });
  }

  document.querySelectorAll("[data-cart-item]").forEach(function (row) {
    var qty = row.querySelector("[data-qty]");
    var input = qty ? qty.querySelector("input") : null;
    var key = row.getAttribute("data-key");
    if (!qty || !input || !key) return;
    function setQty(next) {
      var n = Math.max(0, parseInt(next, 10) || 0);
      input.value = n;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: n })
      }).then(function () {
        window.location.reload();
      });
    }
    qty.querySelector("[data-qty-minus]").addEventListener("click", function () {
      setQty(parseInt(input.value, 10) - 1);
    });
    qty.querySelector("[data-qty-plus]").addEventListener("click", function () {
      setQty(parseInt(input.value, 10) + 1);
    });
    input.addEventListener("change", function () {
      setQty(input.value);
    });
  });
})();
